
export default {

  methods: {
    /**
        *
        * @param {*} type    类型
        * @param {*} data    枚举的数据
        * @param {*} value   枚举值
        */
    enumeration(type = 1, data, value) {
      for (let i = 0; i < data.length; i++) {
        if (parseInt(type) === parseInt(data[i]['type'])) {
          for (const name in data[i].content) {
            const bool = name === value
            if (bool) {
              return data[i]['content'][name]
            }
          }
        }
      }
      return value
    }
  }

}
